import { createSelector } from 'reselect';
import { PushSubscriptionState } from './types';
import { reduxKey, DEFAULT_PUSH_SUBSCRIPTIONS } from './constants';
function getSlice(state) {
    return state[reduxKey] || {
        pushSubscriptionState: PushSubscriptionState.LOADING,
        send: DEFAULT_PUSH_SUBSCRIPTIONS,
        initialized: false
    };
}
export const getPushSubscriptionState = createSelector(getSlice, (slice)=>slice.pushSubscriptionState);
export const getPushSubscriptions = createSelector(getSlice, (slice)=>slice.send);
export const getArePushSubscriptionsInitialized = createSelector(getSlice, (slice)=>slice.initialized);
export const getIsPWABannerHidden = createSelector(getSlice, (slice)=>slice.hidePWABanner);

//# sourceMappingURL=selectors.js.map